import styled from "styles/styled_components";
import BaseButton from "components/shared/base_button";

const StyledMenuButton = styled(BaseButton)`
  margin: 0;
`;

export default StyledMenuButton;
export { ButtonColor } from "components/shared/base_button";
